import { Component } from '@angular/core';

@Component({
    selector: 'arrow-icon',
    template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 14"><path d="M1.337 13.848l6.255-6.255.336-.337-.336-.337L1.337.662l-.674.674 6.255 6.256V6.92L.663 13.173l.674.674z" fill-rule="evenodd"></path></svg>'
})
export class ArrowIcon {}